import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../../providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { ITableColumnHeader } from "../../../models/table-column-header";
import { AddServiceComponent } from "src/app/shared/components/add-service/add-service.component";
import { MatDialog } from "@angular/material/dialog";
import { SharedService } from "../../../providers/shared.service";
import { FormControl } from "@angular/forms";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { TranslateService } from "@ngx-translate/core";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { AuthService } from "src/app/providers/auth.service";

@Component({
  selector: "sm-services",
  templateUrl: "./services.component.html",
  styleUrls: ["./services.component.scss"],
})
export class ServicesComponent implements OnInit, OnDestroy {
  isEntityFitness: any = sessionStorage.getItem("isEntityIndividual")!;
  entityHashId: string = "";
  entityHashIdForSearch: string = "";
  // clickEventSubscription: Subscription
  public loader: boolean = false;
  serviceList: any[] = [];
  private _apiSubscription: Subscription;
  datalength!: number;
  public page: number = 1;
  searchString: FormControl = new FormControl("");
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "services.column_headers.service_name"
      ),
      columnProperty: "serviceName",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.description"
      ),
      columnProperty: "description",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.approx_time"
      ),
      columnProperty: "approxTime",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.home_rate"
      ),
      columnProperty: "home_rate",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.shop_rate"
      ),
      columnProperty: "shop_rate",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.home_discounted_rate"
      ),
      columnProperty: "homeDiscountedPrice",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.shop_discounted_rate"
      ),
      columnProperty: "shopDiscountedPrice",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.service_type"
      ),
      columnProperty: "service_type",
    },
  ];

  constructor(
    private router: Router,
    private _navService: NavigationService,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private sharedService: SharedService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private loaderservice: LoaderServiceService,
    private translateService: TranslateService,
    private authService: AuthService
  ) {
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        const getServiceType = (
          homeStatus: number,
          shopStatus: number,
          for_virtual: number
        ) => {
          const combination =
            (homeStatus << 2) | (shopStatus << 1) | for_virtual;

          switch (combination) {
            case 0b000:
              return "None"; // No services available
            case 0b001:
              return "Virtual";
            case 0b010:
              return "Shop";
            case 0b011:
              return "Shop + Virtual";
            case 0b100:
              return "Home";
            case 0b101:
              return "Home + Virtual";
            case 0b110:
              return "Shop + Home";
            case 0b111:
              return "Shop + Home + Virtual";
            default:
              return "Unknown";
          }
        };
        this.serviceList = [];
        this.datalength = 0;
        if (resData.result) {
          console.log(resData);
          this.datalength = resData.result ? resData.result[0].totalCount : 0;
          this.serviceList = [];
          resData.result.forEach((element: any) => {
            this.serviceList.push(element);
          });
          this.serviceList.forEach((element) => {
            if (element.homeStatus != 1) {
              element.home_rate = "-";
            }
            if (element.shopStatus != 1) {
              element.shop_rate = "-";
            }
            if (element.for_virtual != 1) {
              element.virtual_rate = "-";
            }
            if (
              element.shopDiscountedPrice == null ||
              element.shopDiscountedPrice == 0
            ) {
              element.shopDiscountedPrice = "-";
            }
            if (
              element.homeDiscountedPrice == null ||
              element.homeDiscountedPrice == 0
            ) {
              element.homeDiscountedPrice = "-";
            }
            if (
              element.virtual_discounted_amount == null ||
              element.virtual_discounted_amount == 0
            ) {
              element.virtual_discounted_amount = "-";
            }
            element.service_type = getServiceType(
              element.homeStatus,
              element.shopStatus,
              element.for_virtual
            );
          });
          console.log(this.serviceList);
          // this.serviceList.forEach((item )=> {
          //   item.addressInfo = JSON.parse(item.addressInfo).address_line
          // })
          console.log(this.serviceList);
        }
        this.loader = false;
        this.loaderservice.showLoader = false;
      } else if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_SERVICE_DATA_BY_KEYWORD
      ) {
        const getServiceType = (
          homeStatus: number,
          shopStatus: number,
          for_virtual: number
        ) => {
          const combination =
            (homeStatus << 2) | (shopStatus << 1) | for_virtual;

          switch (combination) {
            case 0b000:
              return "None"; // No services available
            case 0b001:
              return "Virtual";
            case 0b010:
              return "Shop";
            case 0b011:
              return "Shop + Virtual";
            case 0b100:
              return "Home";
            case 0b101:
              return "Home + Virtual";
            case 0b110:
              return "Shop + Home";
            case 0b111:
              return "Shop + Home + Virtual";
            default:
              return "Unknown";
          }
        };
        this.serviceList = [];
        this.datalength = 0;
        console.log(resData);
        // if(resData.result && resData.result != null){
        //   resData.result.forEach((element:any) => {
        //     this.serviceList.push(element)
        //   });

        // }
        if (resData.result) {
          this.datalength = resData.result ? resData.result[0].totalCount : 0;

          resData.result.forEach((element: any) => {
            this.serviceList.push(element);
          });
          // if (this.selectedValue == '1') {
          //   resData.result.forEach((element: any) => {
          //     if (element.shopStatus == 1) {
          //       this.serviceList.push(element);
          //     }
          //   });
          //   // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          // } else if (this.selectedValue == '0') {
          //   resData.result.forEach((element: any) => {
          //     if (element.homeStatus == 1) this.serviceList.push(element);
          //   });
          //   // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          // }
          this.serviceList.forEach((element) => {
            if (element.homeStatus != 1) {
              element.home_rate = "-";
            }
            if (element.shopStatus != 1) {
              element.shop_rate = "-";
            }
            if (element.for_virtual != 1) {
              element.virtual_rate = "-";
            }
            if (
              element.shopDiscountedPrice == null ||
              element.shopDiscountedPrice == 0
            ) {
              element.shopDiscountedPrice = "-";
            }
            if (
              element.homeDiscountedPrice == null ||
              element.homeDiscountedPrice == 0
            ) {
              element.homeDiscountedPrice = "-";
            }
            if (
              element.virtual_discounted_amount == null ||
              element.virtual_discounted_amount == 0
            ) {
              element.virtual_discounted_amount = "-";
            }
            element.service_type = getServiceType(
              element.homeStatus,
              element.shopStatus,
              element.for_virtual
            );
          });
        }
      } else if (
        resData.responseType === SM_CONSTANTS.ADD_UPDATE_SERVICE_TYPE_RESULT
      ) {
        if (resData.result && resData.result != null) {
          if (resData.result.errorcode == 2) {
            this.loaderservice.showLoader = false
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                width: "400px",
                data: {
                  title: "Alert",
                  message: "This service could not be deleted as it is linked with active or ex-members in your business. Please unlink the service from the member and try again.",
                  okbtn: "Ok",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              }
            );
          }
          else{
            this._apiService.getServices(
              this.entityHashId,
              this.selectedValue,
              this.page.toString()
            );

          }
        }
      }
    });
    console.log(this.serviceList);
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = [
        "service_name",
        "description",
        "approx_time",
        "home_rate",
        "shop_rate",
        "home_discounted_rate",
        "shop_discounted_rate",
      ];

      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `services.column_headers.${data[index]}`
      );
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.enPubHash;
      this.entityHashIdForSearch = data.entityHash;
    });

    this._apiService.getServices(
      this.entityHashId,
      this.selectedValue,
      this.page.toString()
    );
    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.loader = true;
    //   this._apiService.getServices(this.entityHashId)
    // });
  }
  selectedValue: string = "0";
  changeChip(value: string) {
    this.selectedValue = value;
    // this.loader = true
    this.loaderservice.showLoader = true;
    if (value == "0") {
      this._apiService.getServices(
        this.entityHashId,
        this.selectedValue,
        this.page.toString()
      );
    } else if (value == "1") {
      this._apiService.getServices(
        this.entityHashId,
        this.selectedValue,
        this.page.toString()
      );
    }
  }
  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService() {
    let dialogref = this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Add service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this._apiService.getServices(
          this.entityHashId,
          this.selectedValue,
          this.page.toString()
        );
      }
    });
  }
  onCreateNewServiceFromTemplate() {
    let dialogref = this._modelRef.open(AddServiceTemplateItemComponent, {
      width: "1000px",
      data: {
        title: "Add service From Template",
        ref: this._modelRef,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this._apiService.getServices(
          this.entityHashId,
          this.selectedValue,
          this.page.toString()
        );
      }
    });
  }

  deactivateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 7,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashIdForSearch);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  activateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashIdForSearch);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      // width: "400px",
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this service?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let metadata = {
          serviceTypeInfo: {
            hash_id: rowvalue.hash_id,
            isDelete: 1,
          },
        };
        this.loaderservice.showLoader = true;
        this._apiService.addUpdateServiceType(
          metadata,
          this.entityHashIdForSearch
        );
      }
    });

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue: any) {
    this.loaderservice.showLoader = true;
    let dialogref = this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Edit service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this._apiService.getServices(
          this.entityHashId,
          this.selectedValue,
          this.page.toString()
        );
      }
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    this._apiService.getServices(
      this.entityHashId,
      this.selectedValue,
      this.page.toString()
    );
  }

  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this._apiService.getServiceDataByKeyword(
        this.entityHashIdForSearch,
        this.page,
        this.searchString.value
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;
        this._apiService.getServices(
          this.entityHashId,
          this.selectedValue,
          this.page.toString()
        );
      }
    }
  }

  openvideo() {
    this._modelRef.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/BsZJGIytwDI?si=6GzijsXV8uwY2sD9",
        title:
          "Adding Service, Creating Catalog in LookzUp Business Web Portal.",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  reset() {
    this.searchString.reset();
    this.page = 1;
    this._apiService.getServices(
      this.entityHashId,
      this.selectedValue,
      this.page.toString()
    );
  }

  openLink(url: string): void {
    window.open(url, "_blank");
  }

  changeStatus(item: any, status: any) {
    this.loaderservice.showLoader = true;

    let metadata = {
      serviceTypeInfo: {
        serviceName: item.serviceName,
        approxTime: item.approxTime,
        description: item.description,
        shop_rate: item.shop_rate && item.shop_rate != "-" ? item.shop_rate : 0,
        home_rate: item.home_rate && item.home_rate != "-" ? item.home_rate : 0,
        virtualRate:
          item.virtual_rate && item.virtual_rate != "-" ? item.virtual_rate : 0,
        virtual_rate:
          item.virtual_rate && item.virtual_rate != "-" ? item.virtual_rate : 0,
        imgUrl: item.imgUrl,
        thumbUrl: item.thumbUrl,
        status: status,
        homeStatus: item.homeStatus,
        shopStatus: item.shopStatus,
        virtualStatus: item.for_virtual,
        for_virtual: item.for_virtual,
        discountStatus: item.discountStatus,
        discountAmount: item.discountAmount,
        shopDiscountedPrice:
          item.shopDiscountedPrice && item.shopDiscountedPrice != "-"
            ? item.shopDiscountedPrice
            : 0,
        homeDiscountedPrice:
          item.homeDiscountedPrice && item.homeDiscountedPrice != "-"
            ? item.homeDiscountedPrice
            : 0,
        virtualDiscountedPrice:
          item.virtual_discounted_amount &&
          item.virtual_discounted_amount != "-"
            ? item.virtual_discounted_amount
            : 0,
        virtual_discounted_amount:
          item.virtual_discounted_amount &&
          item.virtual_discounted_amount != "-"
            ? item.virtual_discounted_amount
            : 0,
        tax_collecion_status: item.tax_collection_status,
        rate: item.rate,
        businessHashId: item.businessHashId,
        hash_id: item.hash_id,
        currency: item.currency,
        currency_symbol: item.currency_symbol,
        tax_collection_status: item.tax_collection_status,
        tax_slab_hash: item.tax_slab_hash,
        discountType: item.discountType,
      },
    };

    Object.keys(metadata.serviceTypeInfo).forEach((key) => {
      if ((metadata.serviceTypeInfo as any)[key] === null) {
        delete (metadata.serviceTypeInfo as any)[key];
      }
    });

    this._apiService.addUpdateServiceType(metadata, this.entityHashIdForSearch);
  }
}
